<template>
  <main class="data-table">
    <leads-list />
  </main>
</template>

<script>
import LeadsList from "@views/leads/components/LeadsList";

export default {
  components: {
    LeadsList,
  },

  data() {
    return {};
  },

  beforeCreate() {},

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
.grid {
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  margin: -14px;

  .loading {
    margin: 0 auto;
  }

  .no-data {
    text-align: center;
    width: 100%;
    font-weight: 400;
  }
}
</style>
